import type { IdentifyTraitsQueryData } from "./IdentifyTraits.query";

export interface IdentifyTraitsData {
  hasSentFirstTpWithLabs: boolean;
  hasSentSecondTpWithLabs: boolean;
  hasSentFourthTpWithLabs: boolean;
  hasSentSixthTpWithLabs: boolean;
  hasAcceptedLabsBaa: boolean;
  userId: string;
  appcuesUserIdSignature: string;
  anyCredentialApproved: boolean;
  createdAt: number;
  firstName: string;
  location: string;
  role: string;
  intent: string;
  modality: string;
  hasMargin: boolean;
  promoOptInStatus: string;
  promoActiveOptInPeriodEndsAt: number;
  colorScheme: string;
  loading: boolean;
}

const useIdentifyTraitsData = () => {
  const getIdentifyTraitsData = (
    data: IdentifyTraitsQueryData,
    loading: boolean,
    colorScheme: string
  ): IdentifyTraitsData => {
    let msSinceEpoch = 0;
    if (data?.currentUser?.createdAt) {
      msSinceEpoch = new Date(data.currentUser.createdAt).getTime();
    }
    const intentions = [];
    if (data?.currentStore?.onboarding?.wholesaleIntention) {
      intentions.push("wholesale_intention");
    }
    if (data?.currentStore?.onboarding?.rxIntention) {
      intentions.push("rx_intention");
    }
    let roleType = data?.currentRole?.type;
    if (roleType === "Practitioner") {
      roleType = data?.currentPractitioner?.isStoreOwner
        ? "owner_practitioner"
        : "sub_practitioner";
    }
    let promoStatus = "None";
    if (data?.currentStore?.globalPatientPromotion?.optIn) {
      promoStatus = "Global";
    } else if (data?.currentStore?.marginType === "never") {
      promoStatus = "NeverMargin";
    } else if (data?.currentStore?.patientPromotionOptInStatus) {
      promoStatus = "Active";
    }

    return {
      hasSentFirstTpWithLabs: data?.currentPractitioner?.hasSentFirstTpWithLabs,
      hasSentSecondTpWithLabs: data?.currentPractitioner?.hasSentSecondTpWithLabs,
      hasSentFourthTpWithLabs: data?.currentPractitioner?.hasSentFourthTpWithLabs,
      hasSentSixthTpWithLabs: data?.currentPractitioner?.hasSentSixthTpWithLabs,
      hasAcceptedLabsBaa: data?.currentPractitioner?.hasAcceptedLabsBaa,
      userId: data?.currentUser?.id,
      appcuesUserIdSignature: window.AppcuesSettings?.userIdSignature
        ? window.AppcuesSettings?.userIdSignature
        : "",
      anyCredentialApproved: data?.currentRole?.anyCredentialApproved,
      createdAt: msSinceEpoch,
      firstName: data?.currentUser?.firstName,
      location: data?.viewer?.countryIso,
      role: roleType,
      intent: intentions.join(", "),
      modality: data?.currentPractitioner?.practitionerType?.description,
      promoOptInStatus: promoStatus,
      promoActiveOptInPeriodEndsAt: data?.viewer?.patientPromotionCutOffDate,
      hasMargin: data?.currentStore?.marginType === "variable",
      colorScheme,
      loading,
    };
  };

  return getIdentifyTraitsData;
};

export { useIdentifyTraitsData };
